import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InboxIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V16H8.56C9.25 17.19 10.53 18 12.01 18C13.49 18 14.76 17.19 15.46 16H19V19ZM19 14H14.01C14.01 15.1 13.11 16 12.01 16C10.91 16 10.01 15.1 10.01 14H5V5H19V14Z" />
  </Icon>
);

export default memo(InboxIcon);
